import { Types } from '@src/app/core/models/configuration.model';
import { SubscriptionModelsUtilService } from '../../../core/services/ib-subscription-models-utils-service';
import { SubscriptionModelsConfigurationService } from '../../services/ib-subscription-models-configuration/ib-subscription-models-configuration-service';
import angular from 'angular';
import { CommonsSessionStorageService } from 'ib-web-commons/utils';
const componentOptions = {
    bindings: {},
    controllerAs: 'subscriptionModelsConfigurationCtrl',
    templateUrl: ['SubscriptionModelsAppConstants', (SubscriptionModelsAppConstants: SubscriptionModelsAppConstant): string => `${SubscriptionModelsAppConstants.templatesRoute}ib-subscription-models-configuration-view.html`]
};
const componentInfo = {
    module: 'ib-subscription-models-configuration-module',
    selector: 'ibSubscriptionModelsConfiguration',
    inject:['$location',
        'SubscriptionModelsAppConstants',  'NewMainHeaderFacade',
        'SubscriptionModelsUtilService',  'SubscriptionModelsConfigurationService',
        'CommonsModalService', 'DatalayerUtilsService', '$translate',
        '$filter', 'CommonsGetWcsPhonesService', 'IbCAuthTokenService', '$rootScope', 'CommonsKeepAliveUtilsService', 'CommonsSessionStorageService'],
    required: ['ib-subscription-models-configuration-form-module', 'ib-subscription-models-service-module']
};
export class ibSubscriptionModelsConfiguration implements ng.IController {
    public model: Types.ConfigurationModel;
    public importSelected: Types.FixedPrice;
    constructor (private $location: ng.ILocationService,
        private SubscriptionModelsAppConstants: SubscriptionModelsAppConstant, private NewMainHeaderFacade: any,
        private SubscriptionModelsUtilService: SubscriptionModelsUtilService, private SubscriptionModelsConfigurationService: SubscriptionModelsConfigurationService,
        private CommonsModalService: CommonsModalService, private DatalayerUtilsService: DatalayerUtilsService, private $translate: angular.translate.ITranslateService,
        private $filter: angular.IFilterService, private CommonsGetWcsPhonesService: any, private IbCAuthTokenService: any, private $rootScope: CommonsRootScope, private CommonsKeepAliveUtilsService: CommonsKeepAliveUtilsService, private CommonsSessionStorageService: CommonsSessionStorageService ) {

    }
    active = (): any => {
        this.model = this.SubscriptionModelsConfigurationService.initializeModel();
        this.importSelected = null;
        const paymentStatus = this.SubscriptionModelsUtilService.getParameterByName(this.SubscriptionModelsAppConstants.nameParameters.paymentStatus);
        const componentType = this.SubscriptionModelsUtilService.getParameterByName(this.SubscriptionModelsAppConstants.nameParameters.componentType);
        const redirectStatus = !!(paymentStatus === this.SubscriptionModelsAppConstants.PAYMENTS.PAYMENTSTATUSOK || paymentStatus === this.SubscriptionModelsAppConstants.PAYMENTS.PAYMENTSTATUSKO || componentType);
        const redirectionPaymentCallback: any = this.CommonsSessionStorageService.get('redirectionPaymentCallback');
        if (redirectionPaymentCallback && redirectionPaymentCallback.status && redirectStatus) {
            this.CommonsKeepAliveUtilsService.initKeepAlive();
            this.CommonsSessionStorageService.set('nextStepAllowed', true);
            angular.extend(redirectionPaymentCallback, {
                redirectStatus: redirectStatus,
                paymentStatus: paymentStatus === this.SubscriptionModelsAppConstants.PAYMENTS.PAYMENTSTATUSKO ? false : paymentStatus === this.SubscriptionModelsAppConstants.PAYMENTS.PAYMENTSTATUSOK || componentType || false
            });
            this.CommonsSessionStorageService.set('redirectionPaymentCallback', redirectionPaymentCallback);
            const datalayer_back = this.CommonsSessionStorageService.get('datalayer_general_Back');
            if (datalayer_back) {
                this.DatalayerUtilsService.updateDatalayerWithQuadrigam(null, datalayer_back, this.SubscriptionModelsUtilService.isUserLogged());
            }
            this.DatalayerUtilsService.updateDatalayerWithQuadrigam(this.SubscriptionModelsAppConstants.QUADRIGAMS.GIFTCARDS_PAYMENT, null, this.SubscriptionModelsUtilService.isUserLogged());
            this.$location.path('/PLPURC');
        } else {
            this.CommonsModalService.showWaitingModal('ib-modal-loading-plane', 'ib-modals ib-modals--transparent ib-modals--loading-page', true);
            this.IbCAuthTokenService.getAnonymousToken().then(() => {
                this.CommonsGetWcsPhonesService.getPhoneByCode(this.SubscriptionModelsAppConstants.WCS.PHONE_TYPES.SALES).then(() => {
                    this.$rootScope.phonesList = this.CommonsSessionStorageService.get('phonesList') || {};
                });

            }, () => {
                this.$location.path('/error');
            });
            this.CommonsSessionStorageService.remove('headerModel');
        }

    };
    $onInit = this.active();
}
try {
    const mod = angular.module(componentInfo.module);
    ibSubscriptionModelsConfiguration.$inject = componentInfo.inject;
    mod.component(
        componentInfo.selector,
        angular.extend(componentOptions, { controller: ibSubscriptionModelsConfiguration })
    );
} catch (error) {
    const mod = angular.module(componentInfo.module, componentInfo.required);
    ibSubscriptionModelsConfiguration.$inject = componentInfo.inject;
    mod.component(
        componentInfo.selector,
        angular.extend(componentOptions, { controller: ibSubscriptionModelsConfiguration })
    );
}
